<template>
  <modal
    id="rollover-modal"
    ref="modal"
    v-model="isModalOpen"
    @hide="handleModalClose"
    :footer="false"
  >
    <div slot="header">
      <h4 v-if="order">Rollover Order to another delivery date</h4>
      <div v-if="order">
        Account: {{ order.account }} — Order: {{ order.skOrderNum }}/{{
          order.skCustRef
        }}
      </div>
    </div>

    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="rollover-delivery-on">New delivery on</label>
        <input
          id="rollover-delivery-on"
          type="date"
          class="form-control"
          :min="minDeliveryOn"
          v-model="deliveryOn"
          required
        />
      </div>

      <div class="form-group">
        <label for="rollover-reason">Rollover reason</label>
        <select
          id="rollover-reason"
          class="form-control"
          v-model="reason"
          required
        >
          <option value="Rollover">Rollover (no charge)</option>
          <option value="Reattempt">Reattempt (charge)</option>
        </select>
      </div>

      <div class="form-group">
        <label for="rollover-note">Note</label>
        <textarea
          id="rollover-note"
          class="form-control"
          v-model="note"
          placeholder="Extra notes"
          required
        ></textarea>
      </div>

      <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>
      <div v-if="successMessage" class="text-success">
        {{ successMessage }}
      </div>

      <div style="display: flex; justify-content: space-between">
        <btn type="button" @click="isModalOpen = false" :disabled="isSubmitting"
          >Cancel</btn
        >
        <btn v-if="isSubmitting" type="primary" native-type="submit" disabled
          >Rolling over...</btn
        >
        <btn
          v-else
          type="primary"
          native-type="submit"
          :disabled="!isValid || wasSubmitted"
          >Rollover Order</btn
        >
      </div>
    </form>
  </modal>
</template>

<script>
import { rolloverOrder } from '@/api';

function formatDate(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export default {
  name: 'RolloverModal',
  props: ['order'],
  data() {
    return {
      isModalOpen: false,
      isSubmitting: false,
      wasSubmitted: false,
      deliveryOn: '',
      reason: 'Rollover',
      note: '',
      errorMessage: '',
      successMessage: '',
    };
  },
  computed: {
    minDeliveryOn() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return formatDate(tomorrow);
    },
    isValid() {
      return (
        this.deliveryOn &&
        this.reason &&
        this.note &&
        this.note.trim().length > 0
      );
    },
    userId() {
      return Sidekick.decode('sidekick.userId') || '';
    },
  },
  watch: {
    order(value) {
      if (value) {
        this.resetForm();
        this.isModalOpen = true;
      }
    },
  },
  methods: {
    resetForm() {
      this.deliveryOn = '';
      this.reason = 'Rollover';
      this.note = '';
      this.errorMessage = '';
      this.successMessage = '';
      this.wasSubmitted = false;
    },
    handleModalClose() {
      this.$emit('onClose');
    },
    async submit() {
      if (!this.isValid || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';

      const result = await rolloverOrder({
        orderId: this.order.skId,
        userId: this.userId,
        deliveryOn: this.deliveryOn,
        reason: this.reason,
        note: this.note,
      });

      this.isSubmitting = false;

      if (result.success) {
        this.wasSubmitted = true;
        this.successMessage =
          'Rollover submitted. A confirmation email will be sent when it completes.';
      } else {
        this.errorMessage = result.message || 'Rollover failed.';
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 12px;
}
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}
.text-danger {
  color: #b94a48;
  margin-bottom: 8px;
}
.text-success {
  color: #468847;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/RolloverModal.vue